import React, { ComponentType } from 'react'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { configuration } from './configuration'
import { Items } from './typings/Config'
import { AppWrapper } from './components/App/AppWrapper'
import { ConfigurationProvider } from './components/App/ConfigurationProvider'
import { UserProvider } from './components/App/UserProvider'

export interface App {
  name: string
  visibleName: string
  iconUrl: string
  url: string
  component: ComponentType
  submenus?: {
    items?: Items[]
    name: string
    url: string
  }[]
}

export const configs = () => {
  const App = () => {
    return (
      <Provider store={store}>
        <ConfigurationProvider>
          <UserProvider>
            <AppWrapper />
          </UserProvider>
        </ConfigurationProvider>
      </Provider>
    )
  }

  const config: App = {
    ...configuration,
    component: App
  }

  return config
}
